<template>
  <div>
    <h3>Question</h3>
    
    <vs-breadcrumb class="mt-2">
      <li><router-link to="/surveys">Surveys</router-link><span class="vs-breadcrum--separator">/</span></li>
      <li><router-link :to="parentSurveyLink">{{ surveyType | formatSurveyType}} - {{ $translate(surveyTitle) }}</router-link><span class="vs-breadcrum--separator">/</span></li>
      <li v-if="hasModules"><router-link :to="parentModuleLink">{{ $translate(moduleTitle) }}</router-link><span class="vs-breadcrum--separator">/</span></li>
      <li v-if="hasLessons"><router-link :to="parentLessonLink">{{ $translate(lessonTitle) }}</router-link><span class="vs-breadcrum--separator">/</span></li>
      <li aria-current="page" class="active">{{ $translate(questionTitle) }}</li>
    </vs-breadcrumb>
    
    <vs-tabs
      :position="isSmallerScreen ? 'top' : 'left'"
      class="tabs-shadow-none mt-8"
      id="profile-tabs"
      :key="isSmallerScreen"
    >
      <!-- GENERAL -->
      <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'General' : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <question-general v-if="item" :question="item" />
        </div>
      </vs-tab>

      <!-- CONFIG -->
      <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'Config' : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <question-config v-if="item" :question="item" />
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import QuestionGeneral from "./QuestionGeneral.vue";
import QuestionConfig from "./QuestionConfig.vue";

export default {
  components: {
    QuestionGeneral,
    QuestionConfig
  },
  data() {
    return {
      item: null,

      surveyType: '',
      surveyId: '',
      moduleId: '',
      lessonId: '',
      questionId: '',

      surveyTitle: '',
      moduleTitle: '',
      lessonTitle: '',
      questionTitle: '',

      hasModules: false,
      hasLessons: false
    };
  },
  methods: {
    getQuestion: function () {
      this.$vs.loading()

      const url = process.env.VUE_APP_API +'/Surveys/' + this.surveyType + '/' + this.surveyId + '/modules/' + this.moduleId + '/lessons/' + this.lessonId + '/questions/' + this.questionId;
      
      this.$http.get(url)
          .then(resp => {
            this.item = resp.data.surveyQuestion;

            this.surveyTitle = resp.data.surveyTitle;
            this.moduleTitle = resp.data.moduleTitle;
            this.lessonTitle = resp.data.lessonTitle;
            this.questionTitle = resp.data.questionTitle;
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {
            this.$vs.loading.close()
          })
    },
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },

    parentSurveyLink() {
      let formattedSurveyType = 'survey';

      if (this.surveyType === '1') {
        formattedSurveyType = 'quiz';
      } else if (this.surveyType === '2') {
        formattedSurveyType = 'checklist'
      } else if (this.surveyType === '3') {
        formattedSurveyType = 'venue-visit'
      } else if (this.surveyType === '4') {
        formattedSurveyType = 'online-training'
      }

      return '/surveys/' + formattedSurveyType + '/' + this.surveyId;
    },
    parentModuleLink() {
      return '/surveys/online-training/' + this.surveyId + '/' + this.moduleId;
    },
    parentLessonLink() {
      return '/surveys/online-training/' + this.surveyId + '/' + this.moduleId + '/' + this.lessonId;
    }
  },
  created() {
    this.surveyType = this.$route.params.surveyType;
    this.surveyId = this.$route.params.surveyId;
    this.moduleId = this.$route.params.moduleId;
    this.lessonId = this.$route.params.lessonId;
    this.questionId = this.$route.params.questionId;

    if (this.surveyType == '4') {
      this.hasModules = true;
      this.hasLessons = true;
    }

    this.getQuestion();
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
